import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { ArrowLeft, FileDown } from "lucide-react";
import { toast } from "sonner";
import ReactMarkdown from "react-markdown";

export default function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  const [downloading, setDownloading] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/news/${id}`);
        setN(data);
      } catch {}
    })();
  }, [id]);

  const downloadPdf = async () => {
    setDownloading(true);
    try {
      const resp = await api.post(
        "/news/report/pdf",
        { news_ids: [id] },
        { responseType: "blob" },
      );
      const blob = new Blob([resp.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Adybo_News_${(n?.title || "news").slice(0, 40).replace(/\W+/g, "_")}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      toast.error("Errore generazione PDF");
    } finally {
      setDownloading(false);
    }
  };

  if (!n) return <div className="text-slate-500">Caricamento…</div>;
  return (
    <div className="max-w-3xl mx-auto space-y-5">
      <div className="flex items-center justify-between">
        <Link to="/news" className="text-sm text-blue-600 flex items-center gap-1"><ArrowLeft size={14} /> Torna alle news</Link>
        <button
          onClick={downloadPdf}
          disabled={downloading}
          className="text-sm brand-gradient text-white rounded-lg px-4 py-2 font-semibold flex items-center gap-2 shadow disabled:opacity-40"
          data-testid="news-detail-download-pdf"
        >
          <FileDown size={15} /> {downloading ? "Preparazione…" : "Stampa PDF"}
        </button>
      </div>
      <div className="card-elevated p-8">
        <div className="flex items-center gap-2 text-xs">
          <span className="badge-neutral !bg-blue-50 !text-blue-700">{n.category}</span>
          <span className="text-slate-400">{fmtDate(n.publication_date)}</span>
        </div>
        <h1 className="mt-3 font-display text-3xl font-bold text-slate-900 leading-tight">{n.title}</h1>
        {n.image_url && <img src={n.image_url} alt={n.title} className="mt-6 rounded-xl w-full object-cover max-h-80" />}
        <div className="mt-6 prose prose-slate max-w-none">
          <ReactMarkdown>{n.body || ""}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
